import { render, staticRenderFns } from "./Type.vue?vue&type=template&id=4a41dc9c&"
import script from "./Type.vue?vue&type=script&lang=ts&"
export * from "./Type.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/builds/riverline/optincollect-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a41dc9c')) {
      api.createRecord('4a41dc9c', component.options)
    } else {
      api.reload('4a41dc9c', component.options)
    }
    module.hot.accept("./Type.vue?vue&type=template&id=4a41dc9c&", function () {
      api.rerender('4a41dc9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/filter/campaign/Type.vue"
export default component.exports